var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{},[_c('b-row',_vm._l((_vm.leases),function(lease){return _c('card-lease-summary',{key:lease.id,attrs:{"md":"6","lease":lease,"listView":_vm.listView}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }